import React, { Component } from 'react';
import styled from 'styled-components';
import em from 'polished/lib/helpers/em';
import BasicButton from '@flow/components/ui/button/BasicButton';
import { NewsletterGroup } from 'types/IOptions';
import { MAIL_CHIMP_SUBSCRIBE_URL } from '@flow/utils/constants';
import { FormattedMessage } from 'react-intl';

const InputWrapper = styled.div`
  flex: 1;
  margin-right: ${em(3.2, 2.8)};
`;

const Input = styled.input`
  background-color: ${props => props.theme.highlightColor};
  font-size: 2.8em;
  width: 100%;
  white-space: nowrap;
  border: none;
  outline: none;
  padding: ${em(2, 2.8)} ${em(1.6, 2.8)};
  color: black;
  font-family: Flow-Poster-Bold;
  text-transform: uppercase;
  box-sizing: border-box;
  
  &:disabled {
    opacity: .7;
  }
  
  &::placeholder {
    color: inherit;
  }
`;

const Form = styled.form`
  white-space: nowrap;
  display: flex;
  align-items: center;
  
  @media only screen and (max-width: 630px) {
    flex-direction: column;
    align-items: flex-end;
    
    ${InputWrapper} {
      margin-bottom: ${em(1, 2.8)};
      margin-right: 0;
      width: 100%;
    }
  }
  @media only screen and (max-width: 550px) {
    ${InputWrapper} {
      font-size: 70%;
    }
  }
`;

const ErrorText = styled.p`
  font-size: 1.8em;
  color: darkred;
  margin-top: 1em;
`;

const SuccessText = styled.p`
  font-size: 1.8em;
  margin-top: 1em;
`;

interface Props {
  newsletter_group: NewsletterGroup;
  langCode: string;
}

interface State {
  inputValue: string;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
}

const INITIAL_STATE = {
  inputValue: '',
  isLoading: false,
  isError: false,
  isSuccess: false,
};

const SUCCESS_STATE = {
  inputValue: '',
  isLoading: false,
  isError: false,
  isSuccess: true,
};

const LOADING_STATE = {
  isLoading: true,
};

class NewsletterForm extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = INITIAL_STATE;
  }

  private _updateInputValue = (event: React.FormEvent<HTMLInputElement>) => {
    this.setState({
      inputValue: event.currentTarget.value
    });
  };

  private _validateEmail = (email: string): boolean => {
    let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  private _handleSubmit = () => {
    const {
      inputValue,
      isLoading,
    } = this.state;

    if (isLoading) return;

    if (this._validateEmail(inputValue)) {
      this.setState(LOADING_STATE, () => {
        try {
          return fetch(MAIL_CHIMP_SUBSCRIBE_URL, {
            body: `u=dfb0247c6994358ec42ae0622&amp;id=12b0fabb66&MERGE0=${inputValue}&cb`,
            headers: {
              'content-type': 'application/x-www-form-urlencoded'
            },
            method: 'POST',
          })
            .then(response => response.json())
            .then(() => this.setState(SUCCESS_STATE))
            .catch(() => {
              this.setState(SUCCESS_STATE);
            })
        } catch(e) {}
      })
    } else {
      this.setState({
        isError: true,
      })
    }
  };

  render() {
    const {
      newsletter_group,
    } = this.props;

    const {
      isError,
      isLoading,
      isSuccess,
    } = this.state;

    return [
      <Form key={1}>
        <InputWrapper>
          <Input
            type='email'
            name='email'
            placeholder={newsletter_group.placelhoder}
            value={this.state.inputValue}
            onChange={event => this._updateInputValue(event)}
            disabled={isLoading}
          />
        </InputWrapper>
        <BasicButton onClick={this._handleSubmit} label={newsletter_group.submit_label}/>
      </Form>,
      (isError) && <ErrorText key={2}><FormattedMessage id='newsletterForm.notValidEmail'/></ErrorText>,
      (isSuccess) && <SuccessText key={3}><FormattedMessage id='newsletterForm.success'/></SuccessText>,
    ]
  }
}

export default NewsletterForm;


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/newsletter/NewsletterForm.tsx